import PropTypes from 'prop-types';
import { Title, TitlePortal, useListContext } from 'react-admin';
import { useTheme } from '@mui/material';

const CustomTitle = ({ title }) => {
    const { defaultTitle } = useListContext();
    const theme = useTheme();

    return (
        <>
            <Title defaultTitle={defaultTitle} title={title} />
            <TitlePortal
                variant='h3'
                component='h3'
                className='page-title'
                sx={{
                    whiteSpace: 'normal',
                    textOverflow: 'inherit',
                    flex: 'auto',
                    [theme.breakpoints.down('md')]: {
                        fontSize: '22px',
                        lineHeight: '28px',
                        marginBottom: '20px',
                        marginTop: '11px',
                        letterSpacing: '-0.44px',
                    },
                    [theme.breakpoints.down('sm')]: {
                        marginBottom: '11px',
                    },
                }}
            />
        </>
    );
};

CustomTitle.propTypes = {
    title: PropTypes.string,
};

export default CustomTitle;
